import { IUploadFile, UploadState } from 'core/slices/upload';
import { IBaseEntity, IPortraitVariant, IPosition, IRotation } from './base';
import { IImage, Orientation } from './image';
import { IModel } from './model';
import { IText } from './text';
import { IVideo, IVideoDAO } from './video';
import { ProcessPhase } from 'core/slices/websocket';

export interface IScene extends IBaseEntity {
  name: string;
  type: SceneType;
  projection: SceneProjection;
  sceneConfigId: number;
  portraitVarId: number;
  thumbnail: string;
  filename: string;
  folderId: number;
  imageId: number;
  videoId: number;
  modelId: number;
  textId: number;
  status: SceneStatus;
  progress: { jobPercentComplete: number; currentPhase: ProcessPhase };
}

export interface ISceneDAO extends IScene {
  image: IImage;
  video: IVideo;
  model: IModel;
  text: IText;
  sceneConfig: ISceneConfig;
  portraitVariant: IPortraitVariant;
  projection: SceneProjection;
  orientation: Orientation;
  upload?: IUploadFile;
}

export interface ISceneBasicDAO extends IScene {
  type: SceneType;
  sceneConfigId: number;
  portraitVarId: number;
}

export type SceneDimensions = {
  width: number;
  height: number;
};

export enum SceneType {
  PHOTO = 0,
  VIDEO = 1,
  MODEL = 2,
}

export enum SceneStatus {
  DELETED = -1,
  ACTIVE = 0,
  PROCESSING = 1,
  ERROR_PROCESSING = 2,
  PROCESS_QUEUED = 3,
}

export enum SceneProjection {
  'STANDARD' = 0,
  '1803D' = 1,
  '3603D' = 2,
  '3DENV' = 3,
}

export enum SceneFit {
  CONTAIN = 0,
  COVER = 1,
}

export interface ISceneConfig extends IBaseEntity {
  sceneId: number;
  positionId: number;
  rotationId: number;
  imageId: number;
  pPositionId: number;
  pRotationId: number;
  pImageId: number;
  duration: number;
  heading: number;
  fit: SceneConfigFit;
  pFit: SceneConfigFit;
  start: number;
  end: number;
  volume: number;
  bgColor: string;
  subtitles: boolean;
  saturation: number;
  brightness: number;
  contrast: number;
  hue: number;
  loop: boolean;
}

export enum SceneConfigFit {
  POSITION = -1,
  FILL = 1,
  CONTAIN = 2,
}

export interface ISceneConfigDAO extends ISceneConfig {
  position: IPosition;
  rotation: IRotation;
  nextPosition: IPosition;
  nextRotation: IRotation;
  image: IImage;
  shouldAnimate?: boolean;
}

export interface IScenePreview {
  id: number;
  url: string;
  name: string;
  size: number;
  sceneConfigId?: number;
  /** Whether the snapshot was taken in portrait — it targets `pImageId` rather than `imageId`. */
  portrait?: boolean;
}
